import { StatusBar } from "expo-status-bar";
import React from "react";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableWithoutFeedback,
  ActivityIndicator,
  Animated,
  Easing,
  Platform,
} from "react-native";
import TouchableOpacity from "app/components/TouchableOpacity";
import Text from "app/components/Text";
import prefActions from "app/utils/prefActions";
import momentActions from "app/utils/momentActions";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import valueActions from "app/utils/valueActions";
import timeHelpers from "app/utils/timeHelpers";
import frequencyHelpers from "app/utils/frequencyHelpers";
import {
  styleSheet,
  screenRatio,
  colors,
  sizes,
  WIDTH,
  HEIGHT,
  DARK,
} from "app/utils/styleSheet";
import filterHelpers from "app/utils/filterHelpers";
// import Toast from "react-native-root-toast";

import Svg, {
  G,
  Path,
  Ellipse,
  Circle,
  Rect,
  TextPath,
  Text as SvgText,
} from "react-native-svg";
import Value from "app/components/Value";
import FilterBar from "app/components/FilterBar";
import Slider from "app/components/Slider";
import TimelineNodes from "app/components/TimelineNodes";
import Icon from "app/components/Icon";

import store from "app/redux/store";

import { Ionicons } from "@expo/vector-icons";

const EMIT = true;

export default class Widget extends React.Component {
  constructor(props) {
    super(props);
    let { navigation, route } = this.props;

    let { values, app } = store.getState();
    let { loading, datetime } = app;
    // values = valueHelpers.applyAncestorIds(values)

    values = filterHelpers.apply(values);
    values = valueHelpers.filterToCurrentRevisions(values);

    this.state = {
      values,
      moments: [],
      families: [],
      cruxColor: null,
      rootValues: [],
      rootValueKey: "focus",
      // rootValueKey: 'todo',
      activeValueKey: null,
      loading,
      datetime,
      // loading: true,
      endAt: null,
      startAt: null,
      scrollY: 0,
      scrollX: 0,
      focusEvent: null,
      lockedFocusFamily: null,
      focusFamily: null,
      timelineValue: null,
      cruxSize: WIDTH < 1200 ? 200 : 100,
      stroke: ENV.WEB ? 12 : 18,
      // stroke: 8,
      rotAnim: new Animated.Value(0),
      range: ENV.WEB ? 10 : 5,
      chunk: "day",
      distributionKey: "chronology",
      showValueShelf: false,
      viewSize: null,
      toastMessage: "",
      autoProgressRot: 0,
    };
  }

  getRootValues = (values) => {
    let { rootValueKey, activeValueKey, datetime } = this.state;
    let rootValues = [...values];
    if (rootValueKey == "focus") {
      rootValues = rootValues.filter((v) => {
        if (store.getState().preferences.focusIds.includes(v.id)) return true;
        // if(!!v.snooze_until && !valueHelpers.isSnoozed(v))
        //   return true
        return false;
      });
    } else if (rootValueKey == "todo") {
      // rootValues = frequencyHelpers.getDueValues(rootValues)

      let dueIds = frequencyHelpers.getDueValues(values).map((v) => v.id);
      let doneIds = frequencyHelpers.getDoneToday(values).map((v) => v.id);
      // let upcomingIds = frequencyHelpers.getUpcoming(values).map(v => v.id)
      let upcomingIds = [];
      let ids = [...doneIds, ...dueIds, ...upcomingIds];
      rootValues = rootValues.filter((v) => ids.includes(v.id));
    } else if (rootValueKey == "unique") {
      rootValues = rootValues.filter((val) => {
        return !!val.color;
      });
      // console.log(rootValues.map(v => v.color))
      // sort by colors
      let orderedColors = [
        "maroon",
        "red",
        "orange",
        "yellow",
        "viridian",
        "green",
        "blue",
        "navy",
        "purple",
        "magenta",
        "pink",
        "gray",
        "cream",
        "brown",
      ];
      let order = {};
      orderedColors.forEach((c, i) => {
        order[c] = i;
      });
      rootValues = rootValues.sort((a, b) => {
        return order[a.color] - order[b.color];
      });

      // rootValues = rootValues.filter(val => {
      //   for(let v of rootValues){
      //     if(valueHelpers.getDescendants(v).map(d => d.id).includes(val.id)){
      //       return false
      //     }
      //   }
      //   return true
      // })
    }
    if (!!activeValueKey) {
      let { endAt, startAt } = this.getTimeRange();
      let recursive = true;
      if (rootValueKey == "chunk") {
        recursive = false;
      }
      rootValues = rootValues.filter((v) => {
        let ts = valueHelpers.getPropagatedUpdatedAt({
          value: v,
          datetimeCutoff: endAt,
          recursive,
        });

        if (rootValueKey == "chunk") {
          if (!!ts && !!rootValues.find((rv) => v.parent_ids.includes(rv.id))) {
            return false;
          }
        }

        // console.log(v.text, ts)
        if (!!ts) {
          let tsDt = new Date(ts).getTime();
          // console.log(tsDt, endAt)
          if (tsDt < endAt && tsDt >= startAt) {
            if (activeValueKey == "active") return true;
            else if (activeValueKey == "inactive") return false;
          }
        }
        if (activeValueKey == "active") return false;
        else if (activeValueKey == "inactive") return true;
      });
    }
    if (rootValueKey == "top") {
      // condense into parents
      rootValues = rootValues.filter((v) => !v.parent_ids?.length);
    }
    rootValues = rootValues.map((v) => {
      // console.log(v.text, valueHelpers.getPropagatedUpdatedAt({value: v, includeCreatedAt: false}))
      return {
        ...v,
        // timestamp: valueHelpers.getPropagatedUpdatedAt({value: v, includeCreatedAt: false}),
      };
    });
    // if(!['all','unique'].includes(rootValueKey)){
    //   rootValues = textHelpers.newestFirst(rootValues, 'timestamp')
    //   // console.log(rootValues)
    // }
    return rootValues;
  };

  getCruxColor = (families) => {
    let uniq = false;
    // return colorHelpers.averageColor(families.map(f => valueHelpers.getColor(f.value)), uniq)
    let familyColors = [];
    families.forEach((family) =>
      this.getRecentProgressions(family).forEach((p) =>
        familyColors.push(valueHelpers.getColor(family.value)),
      ),
    );
    if (!familyColors.length) familyColors = [colors.fill];
    let hex = colorHelpers.averageColor(familyColors, uniq);
    let rgbArray = colorHelpers.hexToRgb(hex, true);
    // console.log(colorHelpers.saturate(rgbArray, 3))
    return colorHelpers.saturate(rgbArray, 3);
  };

  getFamilies = (rootValues) => {
    let { chunk, rootValueKey, moments } = this.state;
    let { endAt, startAt } = this.getTimeRange();
    let families = rootValues.map((value) => {
      return {
        value,
        progressions: valueHelpers.getPropagatedProgressions({
          value,
          includePastRevisions: true,
          includeEmpties: rootValueKey == "todo",
          range: { startAt, endAt },
          chunk,
          moments,
        }),
      };
      // let progressions = valueHelpers.getProgressions({
      //   value,
      //   includePastRevisions: true,
      //   // includeEmpties: true,
      //   includeEmpties: rootValueKey == 'todo',
      //   range: {startAt, endAt},
      // })
      // valueHelpers.getDescendants(value, true).forEach(v => {
      //   progressions = [...progressions, ...valueHelpers.getProgressions({value: v})]
      // })
      // valueHelpers.getPastRevisions(value).forEach(v => {
      //   progressions = [...progressions, ...valueHelpers.getProgressions({value: v})]
      // })
      // progressions = textHelpers.uniq(progressions, 'uid')
      // progressions = textHelpers.newestFirst(progressions, 'timestamp')
      // // progressions = textHelpers.oldestFirst(progressions, 'timestamp')
      // progressions = valueHelpers.condenseProgressions(progressions, chunk)

      // return {
      //   value,
      //   progressions,
      // }
    });

    families = families.map((v) => {
      // console.log(v.text, valueHelpers.getPropagatedUpdatedAt({value: v, includeCreatedAt: false}))
      let timestamp = v.progressions[0]?.timestamp;
      // valueHelpers.getChildren({value: v.value}).forEach(c => {
      //   if(!!c.snooze_until){
      //     console.log('snooze until: ', c.snooze_until, timestamp)
      //   }
      //   if(!!c.snooze_until && (!timestamp || c.snooze_until > timestamp)){
      //     timestamp = c.snooze_until
      //   }
      // })
      return {
        ...v,
        timestamp,
      };
    });

    if (!["all", "unique", "top", "chunk"].includes(rootValueKey)) {
      families = textHelpers.newestFirst(families, "timestamp");
    }

    if (!families.length) return [{ value: {}, progressions: [] }];
    return families;
  };

  getRecentProgressions = (family) => {
    let { range } = this.state;
    let { endAt, startAt } = this.getTimeRange();
    let recentProgressions = family.progressions
      .filter((e) => {
        let ts = new Date(e.timestamp).getTime();
        if (ts < endAt && ts >= startAt) {
          return true;
        }
      })
      .slice(0, range);
    // .reverse()
    recentProgressions = textHelpers.newestFirst(
      recentProgressions,
      "timestamp",
    );
    return recentProgressions;
  };

  getTimeRange = () => {
    let { range, chunk } = this.state;
    let { datetime } = store.getState().app;

    let eod = datetime ? new Date(datetime) : new Date();
    if (chunk == "week") eod = timeHelpers.endOfWeek(eod);
    if (chunk == "month") eod = timeHelpers.endOfMonth(eod);
    eod.setHours(23, 59, 59, 0);
    let endAt = new Date(eod).getTime();
    // console.log(eod)

    let chunkFactor = chunk == "month" ? 30 : chunk == "week" ? 7 : 1;

    let sod = new Date(endAt - (range - 1) * timeHelpers.msInDay * chunkFactor);
    if (chunk == "week") sod = timeHelpers.beginningOfWeek(sod);
    if (chunk == "month") sod = timeHelpers.beginningOfMonth(sod);
    sod.setHours(0, 0, 0, 0);
    // console.log(sod)
    let startAt = new Date(sod).getTime();

    return { endAt, startAt };
  };

  async componentDidMount() {
    this.subscribe();
    this.fetchMoments();
  }

  subscribe = async () => {
    this.unsubscribe = store.subscribe(() => {
      let { values, app } = store.getState();
      let { loading, datetime } = app;
      values = filterHelpers.apply(values);
      // console.log("what", values);
      // console.log(values.find((v) => v.text.includes(" nic")));
      values = valueHelpers.filterToCurrentRevisions(values);
      // console.log(values.find((v) => v.text.includes(" nic")));
      let rootValues = this.getRootValues(values);
      let families = this.getFamilies(rootValues);
      let cruxColor = this.getCruxColor(families);
      let { endAt, startAt } = this.getTimeRange();

      if (datetime != this.state.datetime && !!datetime) {
        this.showTimeRangeToast();
      }

      let resetAnim = false;

      let focusFamily = this.state.focusFamily;
      let lockedFocusFamily = this.state.lockedFocusFamily;
      if (!!focusFamily) {
        focusFamily = families.find((f) => f.value.id == focusFamily.value.id);
        if (!focusFamily) {
          // focus family has been removed
          console.log("focus family has been removed");
          focusFamily = null;
          lockedFocusFamily = null;
          resetAnim = true;
        }
      }
      let timelineValue = this.state.timelineValue;
      if (!!timelineValue) {
        timelineValue = values.find((v) => v.id == timelineValue.id);
      }

      if (families[0]?.value?.id != this.state.families[0]?.value?.id) {
        console.log("families changed, reset anim");
        resetAnim = true;
      }

      if (resetAnim) {
        this.state.rotAnim.setValue(0);
      }

      this.setState({
        values,
        families,
        rootValues,
        focusFamily,
        lockedFocusFamily,
        timelineValue,
        cruxColor,
        loading,
        datetime,
        startAt,
        endAt,
      });
    });

    this.fetch();

    // focus
    this.unsubscribeFocus = this.props.navigation.addListener(
      "focus",
      this.handleFocus,
    );
    if (ENV.WEB) window.addEventListener("focus", this.handleFocus);
    this.unsubscribeBlur = this.props.navigation.addListener(
      "blur",
      this.unsubscribe,
    );
    if (ENV.WEB) window.addEventListener("blur", this.unsubscribe);
  };

  componentWillUnmount() {
    // this.props.navigation.removeListener("focus");
    this.unsubscribeFocus();
    if (ENV.WEB) window.removeEventListener("focus", this.handleFocus);
    // this.props.navigation.removeListener("blur");
    this.unsubscribeBlur();
    if (ENV.WEB) window.removeEventListener("blur", this.handleFocus);
    this.unsubscribe();
  }

  fetch = async () => {
    let { rootValueKey, activeValueKey, datetime } = this.state;
    if (rootValueKey == "focus") {
      let focusIds = store.getState().preferences.focusIds;
      console.log("focusids", focusIds);
      let res = await valueActions.indexFromIds(focusIds);
    } else if (rootValueKey == "todo") {
    } else if (rootValueKey == "unique") {
    }
  };

  fetchMoments = async () => {
    // let { families} = this.state
    // if(!!familes?.length){
    //   let valueIds = families.map(f => f.value.id)
    //   let res = await momentAction
    // }
    let res = await momentActions.index(4);
    console.log("MOMENTS", res);
    if (!!res?.moments?.length) {
      await this.setState({ moments: res?.moments });
      this.updateView(false);
    }
  };

  handleFocus = () => {
    this.subscribe();
    this.updateView(false);
  };

  render() {
    const inspect = false;
    let {
      values,
      rootValues,
      families,
      loading,
      preferences,
      filters,
      range,
      cruxSize,
      stroke,
      scrollY,
      scrollX,
      viewSize,
      cruxColor,
      startAt,
      focusEvent,
      focusFamily,
      timelineValue,
      lockedFocusFamily,
      rotAnim,
      chunk,
      rootValueKey,
      activeValueKey,
      distributionKey,
      showValueShelf,
      toastMessage,
    } = this.state;

    let rotVal = rotAnim.interpolate({
      inputRange: [-360, 0, 360],
      outputRange: ["-360deg", "0deg", "360deg"],
    });

    let canvas = 1000;

    let R = cruxSize + stroke + stroke * 0.8;
    // let maxR = stroke*3*range

    let origin = canvas / 2;
    origin = 0;

    let radians = 2 * Math.PI;
    let angle = radians / families.length;
    let visibleAngle = angle * 0.6;
    let largeCircleFlag = 0;
    if (families.length <= 1) {
      visibleAngle = angle;
      largeCircleFlag = 1;
    }

    let growth = stroke * 2;
    let rotationStep = 360 / families.length;
    let visibleRotationStep = rotationStep * 0.6;

    let maxR = R + growth * range;

    return (
      <View style={styles.wrapper}>
        <FilterBar
          chunk={chunk}
          range={range}
          autoProgress={() => {
            this.setState({ autoProgressRot: this.state.autoProgressRot + 1 });
            this.state.rotAnim.setValue(this.state.autoProgressRot + 1);
            // this.animateRotation(this.state.autoProgressRot+1)
          }}
          navigation={this.props.navigation}
        />

        <View style={styles.sliderRow}>
          <Text
            style={[styles.button, showValueShelf && styles.selectedButton]}
            onPress={() => this.setState({ showValueShelf: !showValueShelf })}
          >
            Values
          </Text>
          <View style={styles.buttonGroup}>
            <Text
              style={[
                styles.button,
                styles.groupedButton,
                chunk == "day" && styles.selectedButton,
              ]}
              onPress={() => this.updateChunk("day")}
            >
              Day
            </Text>
            <Text
              style={[
                styles.button,
                styles.groupedButton,
                chunk == "week" && styles.selectedButton,
              ]}
              onPress={() => this.updateChunk("week")}
            >
              Week
            </Text>
            <Text
              style={[
                styles.button,
                styles.groupedButton,
                chunk == "month" && styles.selectedButton,
              ]}
              onPress={() => this.updateChunk("month")}
            >
              Month
            </Text>
          </View>
          <Text style={[styles.button]}>Range: {range}</Text>
          <Slider
            title={"Timeframe"}
            style={styles.slider}
            value={range}
            onSlidingComplete={this.updateRange}
            minimumValue={1}
            maximumValue={30}
            step={1}
            minimumTrackTintColor={colors.active}
            minimumTrackTintColor={colors.fill}
          />
          <View style={styles.buttonGroup}>
            <Text
              style={[
                styles.button,
                styles.groupedButton,
                rootValueKey == "todo" && styles.selectedButton,
              ]}
              onPress={() => this.updateRootValueKey("todo")}
            >
              ToDo
            </Text>
            <Text
              style={[
                styles.button,
                styles.groupedButton,
                rootValueKey == "focus" && styles.selectedButton,
              ]}
              onPress={() => this.updateRootValueKey("focus")}
            >
              Focus
            </Text>
            <Text
              style={[
                styles.button,
                styles.groupedButton,
                rootValueKey == "all" && styles.selectedButton,
              ]}
              onPress={() => this.updateRootValueKey("all")}
            >
              All
            </Text>
            <Text
              style={[
                styles.button,
                styles.groupedButton,
                rootValueKey == "unique" && styles.selectedButton,
              ]}
              onPress={() => this.updateRootValueKey("unique")}
            >
              Uniq
            </Text>
            <Text
              style={[
                styles.button,
                styles.groupedButton,
                rootValueKey == "top" && styles.selectedButton,
              ]}
              onPress={() => this.updateRootValueKey("top")}
            >
              Top
            </Text>
            <Text
              style={[
                styles.button,
                styles.groupedButton,
                rootValueKey == "chunk" && styles.selectedButton,
              ]}
              onPress={() => {
                this.updateRootValueKey("chunk");
                this.updateActiveValueKey("active");
              }}
            >
              Chunk
            </Text>
          </View>
          <View style={styles.buttonGroup}>
            <Text
              style={[
                styles.button,
                styles.groupedButton,
                activeValueKey == "active" && styles.selectedButton,
              ]}
              onPress={() => this.updateActiveValueKey("active")}
            >
              Active
            </Text>
            <Text
              style={[
                styles.button,
                styles.groupedButton,
                activeValueKey == "inactive" && styles.selectedButton,
              ]}
              onPress={() => this.updateActiveValueKey("inactive")}
            >
              Inactive
            </Text>
          </View>
          <View style={styles.buttonGroup}>
            <Text
              style={[
                styles.button,
                styles.groupedButton,
                distributionKey == "health" && styles.selectedButton,
              ]}
              onPress={() => this.updateDistributionKey("health")}
            >
              Health
            </Text>
            <Text
              style={[
                styles.button,
                styles.groupedButton,
                distributionKey == "chronology" && styles.selectedButton,
              ]}
              onPress={() => this.updateDistributionKey("chronology")}
            >
              Chronology
            </Text>
            <Text
              style={[
                styles.button,
                styles.groupedButton,
                distributionKey == "spiral" && styles.selectedButton,
              ]}
              onPress={() => this.updateDistributionKey("spiral")}
            >
              Spiral
            </Text>
          </View>
        </View>

        {inspect && !!focusEvent && (
          <View style={{ position: "absolute", top: 200 }}>
            <Text>{JSON.stringify(focusEvent, null, 2)}</Text>
          </View>
        )}

        {inspect && !!focusFamily && (
          <View style={{ position: "absolute", top: 0, right: 100 }}>
            <Text>
              {JSON.stringify(
                { progressions: focusFamily.progressions },
                null,
                2,
              )}
            </Text>
          </View>
        )}

        {showValueShelf && (
          <View>
            <ScrollView
              horizontal
              style={{ flexGrow: 0, padding: sizes.giant, overflow: "visible" }}
              contentContainerStyle={{ overflow: "visible" }}
            >
              {rootValues.map((v, i) => (
                <Value
                  key={i}
                  value={v}
                  onPress={() => this.setState({ timelineValue: v })}
                />
              ))}
            </ScrollView>
            {!!timelineValue && (
              <View style={{ flexDirection: "row" }}>
                <TimelineNodes value={timelineValue} />
              </View>
            )}
          </View>
        )}

        <TouchableWithoutFeedback
          style={styles.body}
          onPress={() => {
            console.log("press body");
            this.setState({
              focusEvent: null,
              focusFamily: null,
              lockedFocusFamily: null,
              timelineValue: null,
            });
            this.animateRotation(0);
          }}
        >
          <View
            style={[styles.svgWrapper]}
            onLayout={(event) => {
              let { width, height } = event.nativeEvent.layout;
              {
                /*console.log(width, height)*/
              }
              let viewSize = Math.min(width, height);
              if (WIDTH < 1200) {
                viewSize *= 2;
              }
              this.setState({ viewSize });
            }}
          >
            {!focusFamily && !lockedFocusFamily && (
              <View
                style={{
                  ...StyleSheet.absoluteFillObject,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Svg
                  height="100%"
                  width="100%"
                  viewBox={`0 0 ${canvas} ${canvas}`}
                >
                  <Circle
                    cx={canvas / 2}
                    cy={canvas / 2}
                    r={cruxSize * 0.8 - cruxSize * 0.2 * screenRatio}
                    r={cruxSize * 0.5}
                    // fill={DARK ?`#eeeeee`: '#444'}
                    fill={cruxColor}
                    onClick={() => alert("crux")}
                  />
                </Svg>
                <Text
                  style={[
                    { position: "absolute", fontSize: 16 },
                    ENV.WEB && { fontFamily: "courier" },
                    ENV.LIGHT && { color: colors.empty },
                  ]}
                >
                  {toastMessage}
                </Text>
              </View>
            )}

            {/* renderIcons */}
            {true && (
              <Animated.View
                style={{
                  ...StyleSheet.absoluteFillObject,
                  justifyContent: "center",
                  alignItems: "center",
                  transform: [{ rotate: rotVal }],
                }}
              >
                {families.map((family, i) => {
                  let color = valueHelpers.getColor(family.value);
                  let icon = valueHelpers.getIcon(family.value);
                  if (!icon) return null;
                  let rotation = 180 + rotationStep * i;
                  {
                    /*let size = focusFamily?.value?.id == family.value.id ? 33 : 17*/
                  }
                  {
                    /*let size = focusFamily?.value?.id == family.value.id ? (lockFocusEvent ? 0 : 30) : 17*/
                  }
                  let wrapperSize = 0; // (cruxSize + stroke*3)
                  let iconSize = 0; // 17
                  if (!!viewSize) {
                    wrapperSize = viewSize * 0.2;
                    iconSize = wrapperSize * 0.08;
                  }
                  if (
                    lockedFocusFamily?.value.id == family.value.id ||
                    focusFamily?.value?.id == family.value.id
                  ) {
                    {
                      /*if(!lockFocusEvent && focusFamily?.value?.id == family.value.id){*/
                    }
                    iconSize *= 1.7;
                  }
                  // else iconSize *= 1.4
                  return (
                    <View
                      key={i}
                      style={{
                        position: "absolute",
                        // width: cruxSize*screenRatio*2.5,
                        // height: cruxSize*screenRatio*2.5,
                        width: wrapperSize,
                        height: wrapperSize,
                        //borderWidth: 1, borderColor: 'red',
                        alignItems: "center",
                        transform: [{ rotate: `${rotation}deg` }],
                      }}
                    >
                      <Icon
                        name={icon}
                        color={color}
                        size={iconSize}
                        style={{ transform: [{ rotate: "180deg" }] }}
                      />
                    </View>
                  );
                })}
              </Animated.View>
            )}

            <Animated.View
              style={{
                ...StyleSheet.absoluteFillObject,
                // borderWidth: 4, borderColor:'red',
                justifyContent: "center",
                alignItems: "center",
                transform: [{ rotate: rotVal }],
              }}
            >
              <Svg
                height="100%"
                width="100%"
                viewBox={`0 0 ${canvas} ${canvas}`}
                // onClick={() => {
                //   this.setState({focusEvent: null, focusFamily: null, lockFocusEvent: false, timelineValue: null})
                //   this.animateRotation(0)
                // }}
                // onPress={() => {
                //   console.log('press 509')
                //   this.setState({focusEvent: null, focusFamily: null, lockFocusEvent: false, timelineValue: null})
                //   this.animateRotation(0)
                // }}
              >
                {/*<Rect x={0} y={0} width={canvas} height={canvas} stroke='red' strokeWidth='5' fill='none' />*/}

                {/* slots */}
                {families.map((family, i) => {
                  let bottomRight = { x: 0, y: 0 };
                  let bottomLeft = { x: 0, y: 0 };
                  let topRight = { x: 0, y: 0 };
                  let topLeft = { x: 0, y: 0 };

                  let rotation = 90 - rotationStep / 3 + rotationStep * i;

                  const slotArray = new Array(range).fill(0);
                  return [
                    ...slotArray.map((x, j) => {
                      {
                        /* empty slots */
                      }
                      let cR = R + growth * j;
                      let color = colors.fill;
                      let strokeWidth = stroke;
                      let linecap = "round";

                      // if(j==0){
                      //   cR = cruxSize-stroke
                      //   // let cX = origin + (cR * Math.cos(angle))
                      //   // let cY = origin + (cR * Math.sin(angle))
                      //   color = valueHelpers.getColor(family.value)
                      //   strokeWidth /= 3
                      //   linecap = 'but'
                      // }

                      let cX = origin + cR * Math.cos(visibleAngle);
                      let cY = origin + cR * Math.sin(visibleAngle);

                      if (j == 0) {
                        bottomLeft = { x: cR, y: 0 };
                        bottomRight = { x: cX, y: cY };
                      } else if (j == range - 1) {
                        topLeft = { x: cR, y: 0 };
                        topRight = { x: cX, y: cY };
                      }

                      return (
                        <G
                          key={`${i}-${j}`}
                          rotation={ENV.WEB && rotation}
                          transform={`rotate(${rotation})`}
                          // origin={`${cR / 2}, ${cR / 2}`}
                          x={canvas / 2}
                          y={canvas / 2}
                        >
                          <Path
                            d={`M${origin},${origin} 
                          m ${cR},0
                          A ${cR} ${cR}, 0, ${largeCircleFlag}, 1, ${cX} ${cY}`}
                            fill="none"
                            stroke={color}
                            strokeLinecap={linecap}
                            strokeWidth={strokeWidth}
                            style={{ opacity: 0.4 }}
                            // onMouseEnter={() => {
                            //   // if(j>0) return
                            //   // if(!lockFocusEvent){
                            //   //   this.setState({focusFamily: family})
                            //   // }
                            // }}
                          />
                        </G>
                      );
                    }),
                    <G
                      key={`${i}-family`}
                      rotation={ENV.WEB && rotation}
                      transform={`rotate(${rotation})`}
                      // origin={`${R / 2}, ${R / 2}`}
                      x={canvas / 2}
                      y={canvas / 2}
                    >
                      {/*family blocks*/}
                      <Path
                        d={`M${origin},${origin} 
                          m${bottomLeft.x},0
                          L ${topLeft.x},${topLeft.y}
                          L ${topRight.x},${topRight.y}
                          L ${bottomRight.x},${bottomRight.y}
                          z
                        `}
                        fill="white"
                        stroke={"cyan"}
                        style={{ opacity: 0 }}
                        // strokeLinecap={linecap}
                        strokeWidth={5}
                        // onPress={() => {
                        //   this.animateRotation(
                        //     90 - rotation - visibleRotationStep / 2
                        //   );
                        //   this.setState({
                        //     focusFamily: family,
                        //     lockedFocusFamily: family,
                        //   });
                        // }}
                        onClick={(e) => {
                          console.log("click path!");
                          this.animateRotation(
                            90 - rotation - visibleRotationStep / 2,
                          );
                          this.setState({
                            focusFamily: family,
                            lockedFocusFamily: family,
                          });
                          console.log(family);
                          e.stopPropagation();
                        }}
                        onMouseEnter={() => {
                          // if(!lockFocusEvent){
                          this.setState({ focusFamily: family });
                          // }
                        }}
                        onMouseLeave={() => {
                          console.log("mouse leave family");
                          // if(!lockFocusEvent){
                          this.setState({
                            focusEvent: null,
                            focusFamily: null,
                          });
                          // }
                        }}
                      />
                    </G>,
                  ];
                })}

                {/*<G
                  rotation={ENV.WEB && 45} 
                  transform={`rotate(${45})`}
                  origin={`${R/2}, ${R/2}`} x={canvas/2} y={canvas/2}
                >

                <Path 
                  d={`M${origin},${origin} 
                  l ${R/2},0
                  l 0,${R/2}
                  l ${-R},0
                  l 0,${-R}
                  l ${R},0
                  l 0,${R/2}
                  z`}
                  fill="none" 
                  stroke={'red'} 
                  strokeWidth={15}
                />
                </G>*/}

                {/* deslection ring */}
                <Circle
                  cx={canvas / 2}
                  cy={canvas / 2}
                  r={maxR}
                  fill="none"
                  stroke={"white"}
                  strokeWidth={30}
                  style={{ opacity: 0 }}
                  onMouseEnter={() => {
                    // if(!lockedFocusFamily){
                    this.setState({ focusEvent: null, focusFamily: null });
                    // }
                  }}
                />

                {/* events */}
                {families.map((family, i) => {
                  let recentProgressions = this.getRecentProgressions(family);

                  let color = valueHelpers.getColor(family.value);

                  let familyIsFocused =
                    focusFamily?.value?.id == family.value.id;
                  let familyIsBlurred = !!focusFamily && !familyIsFocused;

                  if (!!recentProgressions.length) {
                    return recentProgressions.map((event, j) => {
                      let placeholderNotch = false;
                      if (["creation", "snooze", "due"].includes(event.type)) {
                        placeholderNotch = true;
                        // color = colors.empty
                      }

                      let cR = R + growth * j;
                      if (["chronology", "spiral"].includes(distributionKey)) {
                        if (distributionKey == "spiral") {
                          if (j !== 0) return null;
                        }
                        let chunkFactor =
                          chunk == "month" ? 30 : chunk == "week" ? 7 : 1;
                        let daysFromStartAt = Math.floor(
                          timeHelpers.daysApart(startAt, event.timestamp) /
                            chunkFactor,
                        );
                        cR = R + growth * daysFromStartAt;
                        if (EMIT && distributionKey != "spiral")
                          cR = maxR - growth - growth * daysFromStartAt;
                      }
                      let cX = origin + cR * Math.cos(visibleAngle);
                      let cY = origin + cR * Math.sin(visibleAngle);

                      let rotation = 90 - rotationStep / 3 + rotationStep * i;

                      const isHovered =
                        focusEvent?.id == event.id &&
                        focusEvent?.timestamp == event.timestamp;

                      return (
                        <G
                          key={j}
                          rotation={ENV.WEB && rotation}
                          transform={`rotate(${rotation})`}
                          // origin={`${cR / 2}, ${cR / 2}`}
                          x={canvas / 2}
                          y={canvas / 2}
                          // style={familyIsBlurred && {opacity: 0.4}}
                        >
                          {isHovered && !familyIsBlurred && (
                            <SvgText
                              x={origin + stroke}
                              y={origin + cR}
                              fill={colors.foreground}
                              textAnchor="left"
                              rotation={ENV.WEB && "-90"}
                              transform={`rotate(-90)`}
                              style={{ fontSize: sizes.base, fontWeight: 100 }}
                              pointerEvents="none"
                            >
                              {event.type == "progress" ? "(✓)" : "(+)"}{" "}
                              {event?.parent?.text || event.text}
                            </SvgText>
                          )}
                          {isHovered && !familyIsBlurred && (
                            <SvgText
                              x={origin + stroke}
                              y={origin + cR + sizes.base * 1.5}
                              fill={colors.foreground}
                              textAnchor="left"
                              rotation={ENV.WEB && "-90"}
                              transform={`rotate(-90)`}
                              style={{ fontSize: sizes.base, fontWeight: 100 }}
                              pointerEvents="none"
                            >
                              {textHelpers.formatTime(event.timestamp, true)} -{" "}
                              {textHelpers.formatDate(event.timestamp, true)}
                            </SvgText>
                          )}
                          {isHovered &&
                            !familyIsBlurred &&
                            !!event.condensed?.length && (
                              <SvgText
                                x={origin + stroke}
                                y={origin + cR + sizes.base * 3}
                                fill={colors.foreground}
                                textAnchor="left"
                                rotation={ENV.WEB && "-90"}
                                transform={`rotate(-90)`}
                                style={{
                                  fontSize: sizes.base,
                                  fontWeight: 100,
                                }}
                                pointerEvents="none"
                              >
                                {focusEvent.uid == event.uid &&
                                !!lockedFocusFamily
                                  ? event.condensed.map((evt) => {
                                      return `${
                                        evt.type == "progress" ? "(✓)" : "(+)"
                                      } ${
                                        evt?.parent?.text || evt.text
                                      } ${textHelpers.formatTime(
                                        evt.timestamp,
                                        true,
                                      )}, `;
                                    })
                                  : `+ ${event.condensed.length} more`}
                              </SvgText>
                            )}

                          {/* progress slot */}
                          <Path
                            d={`M${origin},${origin} 
                          m ${cR},0
                          A ${cR} ${cR}, 0, ${largeCircleFlag}, 1, ${cX} ${cY}`}
                            fill="none"
                            stroke={color}
                            strokeLinecap={"round"}
                            strokeWidth={isHovered ? stroke * 1.5 : stroke}
                            // onPress={() => {
                            //   console.log("press slot");
                            //   this.animateRotation(
                            //     90 - rotation - visibleRotationStep / 2
                            //   );
                            //   this.setState({
                            //     focusEvent: event,
                            //     focusFamily: family,
                            //     lockedFocusFamily: family,
                            //   });
                            // }}
                            onClick={(e) => {
                              this.animateRotation(
                                90 - rotation - visibleRotationStep / 2,
                              );
                              this.setState({
                                focusEvent: event,
                                focusFamily: family,
                                lockedFocusFamily: family,
                              });
                              e.stopPropagation();
                            }}
                            onMouseEnter={() => {
                              console.log(event);
                              // if(!lockFocusEvent){
                              this.setState({
                                focusEvent: event,
                                focusFamily: family,
                              });
                              // }
                              // else {
                              //   this.setState({focusEvent: event})
                              // }
                            }}
                            onMouseLeave={() => {
                              // if(!lockFocusEvent){
                              this.setState({ focusEvent: null });
                              // }
                              // this.setState({focusEvent: null, focusFamily: null})
                            }}
                            style={{
                              transform: [
                                // rotate: `${rotation}deg`,
                                // rotate: `${45}deg`,
                                // {translateX: -1 * (cR/2)},
                                // {rotate: '35deg'},
                                // {translateX: (cR/2)},
                              ],
                              opacity:
                                distributionKey == "health"
                                  ? 1
                                  : (recentProgressions.length - 1 - j + 1) /
                                    (recentProgressions.length - 1 || 1),
                            }}
                          />
                          {placeholderNotch && (
                            <Path
                              d={`M${origin},${origin} 
                            m ${cR},0
                            A ${cR} ${cR}, 0, ${largeCircleFlag}, 1, ${cX} ${cY}`}
                              fill="none"
                              stroke={colors.empty}
                              strokeLinecap={"round"}
                              strokeWidth={
                                isHovered ? stroke * 1.5 * 0.8 : stroke * 0.8
                              }
                              onMouseEnter={() =>
                                this.setState({
                                  focusEvent: event,
                                  focusFamily: family,
                                })
                              }
                              onMouseLeave={() =>
                                this.setState({ focusEvent: null })
                              }
                              onClick={(e) => {
                                this.animateRotation(
                                  90 - rotation - visibleRotationStep / 2,
                                );
                                this.setState({
                                  focusEvent: event,
                                  focusFamily: family,
                                  lockedFocusFamily: family,
                                });
                                e.stopPropagation();
                              }}
                            />
                          )}

                          {/*j == recentProgressions.length-1 && (
                          <SvgText x={0} y={maxR} 
                            fill={familyIsFocused ? colors.foregorund : colors.trim} 
                            textAnchor="middle" 
                            style={{fontSize: sizes.default}} 
                            rotation={-rotationStep*2} 
                            pointerEvents='none'
                          >
                            {family.value.text}
                          </SvgText>
                        )*/}
                        </G>
                      );
                    });
                  }
                })}

                {!ENV.WEB &&
                  families.map((family, i) => {
                    let bottomRight = { x: 0, y: 0 };
                    let bottomLeft = { x: 0, y: 0 };
                    let topRight = { x: 0, y: 0 };
                    let topLeft = { x: 0, y: 0 };

                    let rotation = 90 - rotationStep / 3 + rotationStep * i;

                    const slotArray = new Array(range).fill(0);
                    return [
                      ...slotArray.map((x, j) => {
                        {
                          /* empty slots */
                        }
                        let cR = R + growth * j;
                        let color = colors.fill;
                        let strokeWidth = stroke;
                        let linecap = "round";

                        // if(j==0){
                        //   cR = cruxSize-stroke
                        //   // let cX = origin + (cR * Math.cos(angle))
                        //   // let cY = origin + (cR * Math.sin(angle))
                        //   color = valueHelpers.getColor(family.value)
                        //   strokeWidth /= 3
                        //   linecap = 'but'
                        // }

                        let cX = origin + cR * Math.cos(visibleAngle);
                        let cY = origin + cR * Math.sin(visibleAngle);

                        if (j == 0) {
                          bottomLeft = { x: cR, y: 0 };
                          bottomRight = { x: cX, y: cY };
                        } else if (j == 6) {
                          topLeft = { x: cR, y: 0 };
                          topRight = { x: cX, y: cY };
                        }

                        return (
                          <G
                            key={`${i}-${j}`}
                            rotation={ENV.WEB && rotation}
                            transform={`rotate(${rotation})`}
                            // origin={`${cR / 2}, ${cR / 2}`}
                            x={canvas / 2}
                            y={canvas / 2}
                          >
                            <Path
                              d={`M${origin},${origin} 
                            m ${cR},0
                            A ${cR} ${cR}, 0, ${largeCircleFlag}, 1, ${cX} ${cY}`}
                              fill="none"
                              stroke={color}
                              strokeLinecap={linecap}
                              strokeWidth={strokeWidth}
                              style={{ opacity: 0.4 }}
                              onMouseEnter={() => {
                                // if(j>0) return
                                // if(!lockFocusEvent){
                                //   this.setState({focusFamily: family})
                                // }
                              }}
                            />
                          </G>
                        );
                      }),
                      <G
                        key={`${i}-family`}
                        rotation={ENV.WEB && rotation}
                        transform={`rotate(${rotation})`}
                        // origin={`${R / 2}, ${R / 2}`}
                        x={canvas / 2}
                        y={canvas / 2}
                      >
                        {/*family blocks*/}
                        <Path
                          d={`M${origin},${origin} 
                            m${bottomLeft.x},0
                            L ${topLeft.x},${topLeft.y}
                            L ${topRight.x},${topRight.y}
                            L ${bottomRight.x},${bottomRight.y}
                            z
                          `}
                          fill="white"
                          stroke={"red"}
                          style={{ opacity: 0 }}
                          // strokeLinecap={linecap}
                          strokeWidth={25}
                          onPress={() => {
                            alert("fam block");
                            this.animateRotation(
                              90 - rotation - visibleRotationStep / 2,
                            );
                            this.setState({
                              focusFamily: family,
                              lockedFocusFamily: family,
                            });
                          }}
                          onClick={(e) => {
                            console.log("click path!");
                            this.animateRotation(
                              90 - rotation - visibleRotationStep / 2,
                            );
                            this.setState({
                              focusFamily: family,
                              lockedFocusFamily: family,
                            });
                            console.log(family);
                            e.stopPropagation();
                          }}
                          // onMouseEnter={() => {
                          //   if(!lockFocusEvent){
                          //     this.setState({focusFamily: family})
                          //   }
                          // }}
                          // onMouseLeave={() => {
                          //   console.log('mouse leave family')
                          //   if(!lockFocusEvent){
                          //     this.setState({focusEvent: null, focusFamily: null})
                          //   }
                          // }}
                        />
                      </G>,
                    ];
                  })}

                {/*families.map((family,i) => {
                  let maxR = stroke*3*7
                  // maxR = 0
                  let rotation = (360/(families.length+1))*i
                  rotation = 10
                  return (
                    <SvgText x={canvas/2} y={(canvas/2)+maxR} stroke={colors.trim} textAnchor="middle" rotation={rotation} style={{fontSize: sizes.base}}>
                      {family.value.text}
                    </SvgText>
                  )
                })*/}
              </Svg>
            </Animated.View>

            {(!!focusFamily || !!lockedFocusFamily) && (
              <View style={styles.cruxValueWrapper}>
                <Value
                  // value={lockFocusEvent ? focusFamily.value : {...focusFamily.value, text: ''}}
                  value={focusFamily?.value || lockedFocusFamily?.value}
                  // size={lockFocusEvent ? cruxSize*0.7 : cruxSize*0.5}
                  size={!!viewSize ? viewSize * 0.08 : cruxSize * 0.7}
                  quickActionTimeline
                  coloredNotches
                  quickActionsOnPress
                  // onPress={() => console.log(focusFamily)}
                />
              </View>
            )}
          </View>
        </TouchableWithoutFeedback>
      </View>
    );
  }

  animateRotation = (deg) => {
    // console.log('rotate to: ', deg)
    // deg = deg%360
    let { rotAnim } = this.state;
    deg = this.getShortestRot(rotAnim._value, deg);
    // console.log('shortest deg:', deg)
    Animated.timing(this.state.rotAnim, {
      toValue: deg,
      duration: 500,
      easing: Easing.inOut(Easing.quad),
      useNativeDriver: !ENV.WEB,
    }).start(() => {
      // console.log('rot complete')
    });
  };

  getShortestRot = (direction, newDirection) => {
    const delta = {
      clockwise: (newDirection - direction) % 360,
      counterClockwise: (newDirection - direction - 360) % 360,
    };
    // console.log(direction, newDirection, delta)
    if (Math.abs(delta.clockwise) < Math.abs(delta.counterClockwise))
      return direction + delta.clockwise;
    else return direction + delta.counterClockwise;
  };

  showTimeRangeToast = () => {
    let { chunk } = this.state;
    let datetime = store.getState().app.datetime;
    let message = textHelpers.formatDate(datetime, true, false);
    if (chunk != "day") {
      let { endAt, startAt } = this.getTimeRange();
      console.log(endAt, startAt);
      message = `${textHelpers.formatDate(
        timeHelpers.beginningOfWeek(startAt),
      )} - ${textHelpers.formatDate(timeHelpers.endOfWeek(endAt))}`;
    }
    this.showToast(message);
  };

  showToast = (message) => {
    // // this.setState({toastMessage: message})
    // // return
    // if (this.toast) Toast.hide(this.toast);
    // this.toast = Toast.show(message, {
    //   duration: Toast.durations.LONG,
    //   // position: Toast.positions.TOP,
    //   // position: HEIGHT * 0.75,
    //   position: HEIGHT * 0.95,
    //   shadow: true,
    //   animation: true,
    //   hideOnPress: true,
    //   backgroundColor: colors.foreground,
    //   textColor: colors.empty,
    //   delay: 0,
    //   onShow: () => {
    //     // calls on toast\`s appear animation start
    //   },
    //   onShown: () => {
    //     // calls on toast\`s appear animation end.
    //   },
    //   onHide: () => {
    //     // calls on toast\`s hide animation start.
    //   },
    //   onHidden: () => {
    //     // calls on toast\`s hide animation end.
    //   },
    // });
  };

  updateChunk = async (chunk) => {
    await this.setState({ chunk });
    this.updateView();
  };

  updateRange = async (range) => {
    await this.setState({ range });
    this.updateView();
  };

  updateRootValueKey = async (rootValueKey) => {
    await this.setState({ rootValueKey });
    this.updateView(false);
  };

  updateActiveValueKey = async (activeValueKey) => {
    if (activeValueKey == this.state.activeValueKey) activeValueKey = null;
    await this.setState({ activeValueKey });
    this.updateView(false);
  };

  updateDistributionKey = async (distributionKey) => {
    await this.setState({ distributionKey });
    this.updateView(false);
  };

  updateView = (showToast = true) => {
    let { values, chunk, range } = this.state;
    let rootValues = this.getRootValues(values);
    let families = this.getFamilies(rootValues);
    let cruxColor = this.getCruxColor(families);
    let { endAt, startAt } = this.getTimeRange();
    let cruxSize = WIDTH < 1200 ? 200 : 100;
    if (range < 7) cruxSize *= 2;
    if (families.length > 10) {
      // cruxSize *= 2
    }
    this.setState({
      rootValues,
      families,
      cruxColor,
      cruxSize,
      endAt,
      startAt,
    });
    if (showToast) {
      this.showToast(`Timeframe: ${range} ${chunk}${range > 1 ? "s" : ""}`);
    }
  };
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    justifyContent: "flex-start",
    alignItems: "stretch",
  },
  body: {
    flex: 1,
    // borderWidth: 2, borderColor: 'red',
  },
  svgWrapper: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  sliderRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: sizes.base,
    marginBottom: sizes.base,
  },
  slider: {
    flex: 1,
    marginRight: sizes.base,
  },
  cruxValueWrapper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform:
      Platform.OS == "android"
        ? []
        : [{ translateX: "-50%" }, { translateY: "-50%" }],
  },
  button: {
    padding: sizes.base,
    borderRadius: sizes.borderRadius,
    backgroundColor: colors.fill,
    marginRight: sizes.base,
  },
  selectedButton: {
    backgroundColor: colors.trim,
  },
  buttonGroup: {
    flexDirection: "row",
    borderRadius: sizes.borderRadius,
    overflow: "hidden",
    marginRight: sizes.base,
  },
  groupedButton: {
    borderRadius: 0,
    marginRight: 0,
  },
});
